const styleSheet = () => ({
  label: {
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '36px',
    color: '#223762',
    fontWeight: '800',
    '@media (max-width: 740px)': {
      marginLeft: '0',
      paddingLeft: '0',
    },
  },
  pillContainer: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    '@media (max-width: 740px)': {
      marginLeft: '0',
      paddingLeft: '0',
    },
  },
  pill: {
    backgroundColor: '#fff',
    color: '#223762',
    fontSize: 18,
    fontWeight: 500,
    textWrap: 'nowrap',
    display: 'inline-block',
    border: '1px solid grey',
    borderRadius: '32px',
    padding: '6px 14px',
    cursor: 'pointer',
    transition: '250ms',
  },
  activePill: {
    backgroundColor: '#085fe5',
    color: '#fff',
    border: '1px solid #085fe5',
  },
  toggleContainer: {
    textAlign: 'left',
    padding: '0 10px',
    '@media (max-width: 740px)': {
      padding: 0
    },
  },
  toggleLabel: {
    display: 'flex',
    gap: '8px',
    textAlign: 'left',
    textTransform: 'uppercase',
    paddingLeft: '9px',
    marginBottom: '36px',
    color: '#223762;',
    fontWeight: '800',
    '@media (max-width: 740px)': {
      paddingLeft: '0',
      fontSize: 10,
      margin: '0 0 15px 0'
    },
  },
  togglePillContainer: {
    position: 'absolute',
    background: 'white',
    transition: '.3s ease',
    '@media (max-width: 900px)': {
      position: 'relative',
    },
  },
  showPillContainer: {
    transform: 'translateY(-65vh)',
    height: '65vh',
    overflowY: 'auto',
    '@media (max-width: 900px)': {
      transform: 'translateY(-25vh)',
      height: '50vh',
      marginBottom: '-20vh'
    },
    '@media (max-width: 400px)': {
      transform: 'translateY(-28vh)',
      height: '40vh',
      marginBottom: '-25vh'
    },
    '@media (max-height: 830px)': {
      transform: 'translateY(-25vh)',
      height: '50vh',
    },
    '@media (max-height: 600px)': {
      transform: 'translateY(-40vh)',
      height: '40vh',
    }
  },
  hidePillContainer: {
    transform: 'translateY(0)',
    height: '24px',
    overflow: 'hidden',
  },
  hideToggle: {
    display: 'none'
  },
  noHeaderContainer: {
    transform: 'translateY(-41vh)',
    height: '44vh',
    overflowY: 'auto',
    '@media (max-width: 900px)': {
      transform: 'translateY(-2vh)',
      height: '50vh',
    },
    '@media (max-width: 400px)': {
      transform: 'translateY(-3vh)',
      height: '45vh',
    },
    '@media (max-height: 830px)': {
      transform: 'translateY(-28vh)',
      height: '45vh',
      marginBottom: '-25vh'
    },
    '@media (max-height: 600px)': {
      transform: 'translateY(-40vh)',
      height: '40vh',
    }
  },
  groupLabel: {
    color: 'rgba(99, 115, 164, 1)',
    paddingBottom: '15px',
  },
  icon: {
    cursor: 'pointer',
    transform: 'scale(1.2)'
  }
})

export default styleSheet;